import * as angular from 'angular';
import { ErrorHandler } from 'app/_services/error-handler.factory';

class ShippersDetailsComponentCtrl implements ng.IController {
    public customerRefId: number;
    public assignment: TsoShipperAssignmentsDto;
    public errorLoading: boolean;

    constructor(
        private TransmissionSystemOperator: any,
        private errorHandler: ErrorHandler
    ) {}

    async $onInit() {
        this.loadShipperAssignment();
    }

    public loadShipperAssignment() {
        let params = { customerRefId: this.customerRefId };

        this.TransmissionSystemOperator.assignedShipperForId(
            params,
            (res) => {
                this.assignment = res;
            },
            (err: any) => {
                this.errorLoading = true;
                this.errorHandler(err);
            }
        );
    }
}

angular.module('app').component('pkpShippersDetails', {
    controller: ShippersDetailsComponentCtrl,
    template: require('app/shippers/shippers-details.component.html'),
    bindings: {
        customerRefId: '<'
    }
});
